import fetchDirectory from '../Services/fetchDirectory';
import fetchRootDirectories from '../Services/fetchRootDirectories';

export default () => async (dispatch) => {
  
  dispatch(fetchDirectory());
  dispatch(fetchRootDirectories());
  
}